import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ErrorBoundary } from 'components/errors/error-boundary';

import { DashboardLayout } from 'components/layouts/dashboard-layout';
import { Spinner } from 'components/ui/spinner';
import type { DashboardNavigation } from 'components/layouts/dashboard-layout/types';

type AppRootProps = {
    navigation: DashboardNavigation;
};

export const AppRoot = ({ navigation }: AppRootProps) => {
    const location = useLocation();
    return (
        <DashboardLayout navigation={navigation}>
            <Suspense
                fallback={
                    <div className="flex size-full items-center justify-center">
                        <Spinner size="xl" />
                    </div>
                }
            >
                <ErrorBoundary key={location.pathname}>
                    <Outlet />
                </ErrorBoundary>
            </Suspense>
        </DashboardLayout>
    );
};
